import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import RecordedChapterTable from './RecordedChapter';
const RecordedChapter = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Recorded Chapter' parent='Recorded Chapter'  />
      <Container fluid={true}>
        <Row>
          <RecordedChapterTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default RecordedChapter;
